module.exports = __webpack_public_path__ + "static/media/setupLogo.637f7c19.svg";